// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Login_wrapper__1-h2H","card":"Login_card__1197-","logo":"Login_logo__T1TMP","error":"Login_error__1v_Cw"};